import React from 'react';
import NavAdmin from '../nav-admin/nav-admin';

const HeaderDocument = () => (
    <header className="HeaderDocument" role="banner">
        <nav
            className="navbar navbar-expand-sm navbar-toggleable-sm box-shadow admin-custom-navbar"
            aria-label="Documents and Video Tutorials header bar with admin navigation"
        >
            <div className="container w-max2">
                <h5 className="sp-mx" id="documents-header-title">
                    <i className="bi bi-files" aria-hidden="true"></i>
                    <span className="spacer-margin2 v-set4">Documents  &#38; Media</span>
                </h5>
                <NavAdmin />
            </div>
        </nav>
    </header>
);

export default HeaderDocument;
